import { LoadingIndicatorComponent } from '../../components/loading-indicator/loading-indicator.component';
// @ts-ignore
import { Component, OnInit } from '@angular/core';
// @ts-ignore
import { CommonModule } from '@angular/common';
// @ts-ignore
import { FormsModule } from '@angular/forms';
// @ts-ignore
import { firstValueFrom } from 'rxjs';
import { SankhyaGatewayService } from '../../services/sankhya-gateway.service';

interface MotivoLinha {
  codigo:       number;
  motivo:       string;
  ativo:        string;
  modulo:       string;
  dataCriacao:  string;
  codusu:       number;
  nomeUsuario:  string;
}

// @ts-ignore
@Component({
  selector: 'app-motivo-cancelamento',
  standalone: true,
  imports: [LoadingIndicatorComponent, CommonModule, FormsModule],
  templateUrl: './motivo-cancelamento.component.html',
  styleUrl: './motivo-cancelamento.component.css'
})
export class MotivoCancelamentoComponent implements OnInit {

  // ── Lista ─────────────────────────────────────────────────
  carregando = false;
  motivos: MotivoLinha[] = [];
  erro = '';
  sucesso = '';

  // ── Opções do dicionário ───────────────────────────────────
  opcoesAtivo:  string[] = [];
  opcoesModulo: string[] = [];

  // ── Dropdown de ações ─────────────────────────────────────
  dropdownAberto: number | null = null;

  // ── Modal de formulário ───────────────────────────────────
  modalAberto   = false;
  salvando      = false;
  modoEdicao    = false;
  form = { codigo: 0, motivo: '', ativo: '', modulo: '' };
  erroForm      = '';

  constructor(private readonly gateway: SankhyaGatewayService) {}

  ngOnInit(): void {
    this.carregar();
  }

  async carregar(): Promise<void> {
    this.carregando = true;
    this.erro = '';
    try {
      const [resLista, resOpcoes] = await Promise.all([
        firstValueFrom(this.gateway.listarMotivosCancelamento()),
        firstValueFrom(this.gateway.buscarOpcoesMotivosCancelamento())
      ]);

      const bodyLista: any   = (resLista as any)?.responseBody ?? resLista;
      const bodyOpcoes: any  = (resOpcoes as any)?.responseBody ?? resOpcoes;

      this.motivos       = bodyLista?.lista ?? [];
      this.opcoesAtivo   = bodyOpcoes?.opcoesAtivo  ?? [];
      this.opcoesModulo  = bodyOpcoes?.opcoesModulo ?? [];
    } catch (e: any) {
      this.erro = e?.message ?? 'Erro ao carregar dados.';
    } finally {
      this.carregando = false;
    }
  }

  // ── Dropdown ──────────────────────────────────────────────
  // Posição calculada na hora de abrir (a partir do botão "⋮" clicado) —
  // o menu usa position:fixed (ver CSS .ds-dropdown-menu--flutuante) pra
  // sair por cima da tabela em vez de ficar cortado pelo overflow:auto do
  // ds-table-container.
  dropdownPos: { top: number; right: number } | null = null;

  toggleDropdown(event: Event, codigo: number): void {
    event.stopPropagation();
    if (this.dropdownAberto === codigo) {
      this.dropdownAberto = null;
      this.dropdownPos = null;
      return;
    }
    this.dropdownAberto = codigo;
    const botao = event.currentTarget as HTMLElement;
    const rect = botao.getBoundingClientRect();
    this.dropdownPos = {
      top: rect.bottom + 6,
      right: window.innerWidth - rect.right,
    };
  }

  fecharDropdown(): void {
    this.dropdownAberto = null;
    this.dropdownPos = null;
  }

  // ── Modal novo / editar ───────────────────────────────────
  abrirNovo(): void {
    this.modoEdicao = false;
    this.form = {
      codigo: 0,
      motivo: '',
      ativo: this.opcoesAtivo[0] ?? '',
      modulo: this.opcoesModulo[0] ?? ''
    };
    this.erroForm = '';
    this.modalAberto = true;
  }

  abrirEditar(m: MotivoLinha): void {
    this.modoEdicao = true;
    this.form = { codigo: m.codigo, motivo: m.motivo, ativo: m.ativo, modulo: m.modulo };
    this.erroForm = '';
    this.modalAberto = true;
    this.fecharDropdown();
  }

  fecharModal(): void {
    this.modalAberto = false;
  }

  async salvar(): Promise<void> {
    this.erroForm = '';
    if (!this.form.motivo.trim()) { this.erroForm = 'Informe o motivo.'; return; }
    if (!this.form.ativo)          { this.erroForm = 'Selecione o ativo.'; return; }
    if (!this.form.modulo)         { this.erroForm = 'Selecione o módulo.'; return; }

    this.salvando = true;
    try {
      const payload: any = {
        motivo: this.form.motivo.trim(),
        ativo:  this.form.ativo,
        modulo: this.form.modulo
      };
      if (this.modoEdicao) payload.codigo = this.form.codigo;

      const res: any = await firstValueFrom(this.gateway.salvarMotivoCancelamento(payload));
      const body = res?.responseBody ?? res;

      if (body?.sucesso === true || body?.sucesso === 'true') {
        this.sucesso = body.mensagem ?? 'Salvo com sucesso.';
        this.modalAberto = false;
        await this.carregar();
        setTimeout(() => this.sucesso = '', 3500);
      } else {
        this.erroForm = body?.erro ?? 'Erro ao salvar.';
      }
    } catch (e: any) {
      this.erroForm = e?.message ?? 'Erro de comunicação.';
    } finally {
      this.salvando = false;
    }
  }

  // ── Alterar ativo ─────────────────────────────────────────
  alterando: number | null = null;

  async alterarAtivo(m: MotivoLinha, novoAtivo: string): Promise<void> {
    this.fecharDropdown();
    this.alterando = m.codigo;
    this.erro = '';
    try {
      const res: any = await firstValueFrom(
        this.gateway.alterarAtivoMotivoCancelamento(m.codigo, novoAtivo)
      );
      const body = res?.responseBody ?? res;
      if (body?.sucesso === true || body?.sucesso === 'true') {
        this.sucesso = body.mensagem ?? 'Situação atualizada.';
        await this.carregar();
        setTimeout(() => this.sucesso = '', 3500);
      } else {
        this.erro = body?.erro ?? 'Erro ao alterar situação.';
      }
    } catch (e: any) {
      this.erro = e?.message ?? 'Erro de comunicação.';
    } finally {
      this.alterando = null;
    }
  }

  // ── Helpers ───────────────────────────────────────────────
  ativoClass(ativo: string): string {
    // Classes do design system (design-system.css) — ds-badge já vem no
    // template, aqui só o modificador de cor.
    const v = (ativo ?? '').toLowerCase();
    if (v === 'ativo' || v === 's' || v === 'sim') return 'ds-badge--success';
    return '';
  }

  labelAtivo(ativo: string): string {
    return ativo || '—';
  }

  proximoAtivo(m: MotivoLinha): string {
    if (this.opcoesAtivo.length < 2) return '';
    const idx = this.opcoesAtivo.indexOf(m.ativo);
    return idx >= 0 ? this.opcoesAtivo[(idx + 1) % this.opcoesAtivo.length] : this.opcoesAtivo[0];
  }
}
